import { MATERIAL_MASS_UNIT_COEFFICIENTS, MODEL_UNIT_COEFFICIENTS } from './constants';

export function convertLengthToOtherUnit(length, lengthUnit, requestedUnit) {
  if (!MODEL_UNIT_COEFFICIENTS[lengthUnit]) {
    return null;
  }

  if (!MODEL_UNIT_COEFFICIENTS[lengthUnit][requestedUnit]) {
    return null;
  }

  const coef = MODEL_UNIT_COEFFICIENTS[lengthUnit][requestedUnit];

  return length * coef;
}

export function convertMassToOtherUnit(value, valueUnit, requestedUnit) {
  if (!MATERIAL_MASS_UNIT_COEFFICIENTS[valueUnit]) {
    return null;
  }

  if (!MATERIAL_MASS_UNIT_COEFFICIENTS[valueUnit][requestedUnit]) {
    return null;
  }

  const coef = MATERIAL_MASS_UNIT_COEFFICIENTS[valueUnit][requestedUnit];

  return value * coef;
}
